import { __extends } from 'tslib';
import * as React from 'react';
import classNames from 'classnames';
import StepCSSTransitionGroup from '../Animations/StepCSSTransitionGroup.js';
import styles from './Dialog.module.scss.js';

var DialogFooter = (function (_super) {
    __extends(DialogFooter, _super);
    function DialogFooter(props) {
        return _super.call(this, props) || this;
    }
    DialogFooter.prototype.render = function () {
        var _a;
        var classNameDialogFooter = classNames(styles.footer, (_a = {},
            _a[styles.isOverlayContent] = !!this.props.isOverlayContent,
            _a));
        return (React.createElement(StepCSSTransitionGroup, { level: 3, className: this.props.className || '' },
            React.createElement("div", { key: "footer", className: classNameDialogFooter }, this.props.children)));
    };
    return DialogFooter;
}(React.PureComponent));

export { DialogFooter as default };
//# sourceMappingURL=DialogFooter.js.map
